'use strict';

(function () {
  'use strict';

  angular.module('msOnboarding').controller('GuidelinesCtrl', GuidelineCtrl);

  GuidelineCtrl.$inject = ['$log', 'userSvc', '$state', 'onboardingRouter', 'isLoggedIn'];

  /* @ngInject */
  function GuidelineCtrl($log, userSvc, $state, onboardingRouter, isLoggedIn) {
    var vm = this;
    vm.guidelineAccept = guidelineAccept;
    vm.isLoggedIn = isLoggedIn;

    ////////////////

    function guidelineAccept(value) {
      var _valueMap = { 'agreedToGuidelines': value };
      userSvc.savePreferences(_valueMap, successCallback, errorCallback);
    }

    function successCallback() {
      onboardingRouter.goToNextStep();
    }

    function errorCallback(response) {
      $log.error('Guideline Acceptance could not be saved: ', response);
    }
  }
})();